const CHATBOT_SCRIPT_ID = 'chatbot-iframe';
const CHATBOT_ROOT_ID = 'aibox';
const CHATBOT_BASE_URL = '/bot';
const CHATBOT_PAGE_PATH = '/index.html#/1/2044600076351807490/1/chat';

export function loadChatbot() {
  if (typeof document === 'undefined') {
    return;
  }

  if (document.getElementById(CHATBOT_SCRIPT_ID) || document.getElementById(CHATBOT_ROOT_ID)) {
    return;
  }

  const script = document.createElement('script');
  script.id = CHATBOT_SCRIPT_ID;
  script.src = `${CHATBOT_BASE_URL}/embed.js?t=${Date.now()}`;
  script.setAttribute('data-bot-src', `${CHATBOT_BASE_URL}${CHATBOT_PAGE_PATH}`);
  script.async = true;
  script.defer = true;

  document.body.appendChild(script);
}

export function unloadChatbot() {
  if (typeof document === 'undefined') {
    return;
  }

  document.getElementById(CHATBOT_SCRIPT_ID)?.remove();
  document.getElementById(CHATBOT_ROOT_ID)?.remove();
}
